import ReactGA from "react-ga4";
import { GA_ID } from "../../environment.ts";

export const initGA = () => {
    if (!GA_ID) return;
    ReactGA.initialize(GA_ID);
};

export const logPageView = (path: string) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
